<template>
    <div>
      <VehicleManagement></VehicleManagement>
    </div>
  </template>
  <script>
  import VehicleManagement from "./components/VehicleManagement.vue";
  export default {
    components: {
      VehicleManagement,
    },
    data() {
      return {
        activeName: "first",
      };
    },
    methods: {},
  };
  </script>
  
  <style></style>
  